module.exports = __webpack_public_path__ + "static/media/successIcon.16fb6a8a.svg";